import { newAddPanelReducer as reducer } from './newAddPanelReducer';
import * as selectors from './newAddPanelSelectors';
import * as actions from './newAddPanelActions';

export { reducer, selectors, actions };
